import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type { BrandingV2Interface } from '@vendasta/partner';
import type { User } from '@vendasta/iamv2';

export interface PartnerCenterBillingConfig {
  merchantId$: Observable<string>;
  customerService: CustomerService;
  merchantService: MerchantService;
}

export interface MerchantService {
  getBranding(): Observable<Pick<BrandingV2Interface, 'name' | 'logoUrl' | 'primaryColor'>>;
}

export type CustomerUser = Pick<User, 'firstName' | 'lastName' | 'userId'>;

export interface CustomerService {
  getCustomer(customerId: string): Observable<{ name: string }>;
  getUsers(customerId: string): Observable<CustomerUser[]>;
}

export interface PaymentMethodConfig {
  merchantId: string;
  customerId: string;
  stripeKey: string;
  stripeConnectId: string;
}

export const PARTNER_CENTER_BILLING_CONFIG_TOKEN = new InjectionToken<PartnerCenterBillingConfig>(
  '[Partner Center Billing]: Token for config',
);
